export function getCookie(key) {
    if (!key) {
        return null;
    }
    const escapedKey = encodeURIComponent(key).replace(/[-.+*]/g, '\\$&');
    const value = document.cookie
        .replace(
            new RegExp(`(?:(?:^|.*;)\\s*${escapedKey}\\s*\\=\\s*([^;]*).*$)|^.*$`),
            '$1',
        );
    return decodeURIComponent(value);
}

export function setCookie(cookie) {
    document.cookie = cookie;
}

export function deleteCookie(key, domain) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`;
}



// WEBPACK FOOTER //
// /src/js/common/utils/cookie.js